<template>
	<div class="page-login">
		<div class="page-login--layer page-login--layer-area">
			<ul class="circles">
				<li v-for="n in 10" :key="n"></li>
			</ul>
		</div>
		<div
			class="page-login--layer page-login--layer-time"
			flex="main:center cross:center"
			style="text-align: center"
		>
			{{ time }}
		</div>
		<div class="page-login--layer">
			<div
				class="page-login--content"
				flex="dir:top main:justify cross:stretch box:justify"
			>
				<div
					style="
						display: flex;
						align-items: center;
						justify-content: center;
						min-height: 92vh;
					"
				>
					<div
						class="page-login--content-main"
						flex="dir:top main:center cross:center"
					>
						<!--            <div class="div_txt_info">浪起云科技</div>-->
						<!-- <img class="page-login--logo" src="../../assets/images/top_ico.png"> -->
						<div class="page-login--form">
							<el-card shadow="never" style="padding: 20px">
								<el-form ref="loginForm" label-position="top" size="default">
									<el-form-item prop="username">
										<el-input
											type="text"
											v-model="params.account"
											placeholder="用户名"
											@keydown.enter.native="handleLogin"
										>
											<i slot="prepend" class="el-icon-user"></i>
										</el-input>
									</el-form-item>
									<el-form-item prop="password">
										<el-input
											type="password"
											v-model="params.password"
											placeholder="密码"
											@keydown.enter.native="handleLogin"
										>
											<i slot="prepend" class="el-icon-lock"></i>
										</el-input>
									</el-form-item>
									<el-button
										size="default"
										@click="handleLogin"
										type="primary"
										class="button-login"
									>
										登录
									</el-button>
								</el-form>
							</el-card>
						</div>
					</div>
				</div>
				<div class="page-login--content-footer">
					<p class="page-login--content-footer-copyright">
						Copyright @ 2021-2025 Micro Synaesthesia Limited 版权所有
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import {} from ''../../utils/tools/index
import { isEmpty } from "@utils/tools/index";

export default {
	components: {},

	data() {
		return {
			time: "",
			params: {
				account: "",
				password: "",
			},
			startTime: "",
		};
	},

	created() {
		this.getTime();
		setInterval(() => {
			this.getTime();
		}, 1000);
	},

	watch: {},

	methods: {
		getTime() {
			let date = new Date();
			let hours = date.getHours();
			let minutes = date.getMinutes();
			let seconds = date.getSeconds();
			if (hours <= 9) {
				hours = "0" + hours;
			}
			if (minutes <= 9) {
				minutes = "0" + minutes;
			}
			if (seconds <= 9) {
				seconds = "0" + seconds;
			}
			let strDate = hours + ":" + minutes + ":" + seconds;
			this.time = strDate;
		},
		/**
		 * 登录
		 */
		async handleLogin() {
			if (!isEmpty(localStorage.getItem("userInfo"))) {
				localStorage.removeItem("localStorage");
			}
			if (!this.params.account) {
				this.$message.error("请输入帐号！");
				return;
			}
			if (!this.params.password) {
				this.$message.error("请输入密码！");
				return;
			}
			const { data: resData } = await this.$post("/login", this.params, {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			localStorage.setItem("userInfo", JSON.stringify(resData.data));
			let car_time = resData.data.expiresIn * 1000;
			let times = new Date().getTime();
			this.startTime = times + car_time;
			setInterval(this.timeOut, 1000);
			this.$router.push({
				name: "HOME",
			});
		},

		timeOut() {
			let nowDate = new Date().getTime();
			if (this.startTime <= nowDate) {
				for (var i = 1; i <= 1000; i++) {
					clearInterval(i);
				}
				this.$router.push({ name: "LOGIN" });
				localStorage.removeItem("userInfo");
				sessionStorage.removeItem("tt_menuId");
				//清空路由
				location.reload();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/unit/color.scss";
@import "src/assets/style/public.scss";

.page-login {
	@extend %unable-select;
	$backgroundColor: #f0f2f5;
	// ---
	background-color: $backgroundColor;
	height: 100%;
	position: relative;
	// 层
	.page-login--layer {
		@extend %full;
		overflow: auto;
	}

	.page-login--layer-area {
		overflow: hidden;
	}

	// 时间
	.page-login--layer-time {
		font-size: 24em;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.03);
		overflow: hidden;
		line-height: 100vh;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
			"Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	// 登陆页面控件的容器
	.page-login--content {
		height: 100%;
		min-height: 500px;
		//display: flex;
		//align-items: center;
		//justify-content: center;
	}

	// header
	.page-login--content-header {
		padding: 1em 0;

		.page-login--content-header-motto {
			margin: 0px;
			padding: 0px;
			color: $color-text-normal;
			text-align: center;
			font-size: 12px;
		}
	}

	.page-login--content-main {
		text-align: center;
	}

	// main
	.page-login--logo {
		width: 240px;
		margin-bottom: 2em;
	}

	// 登录表单
	.page-login--form {
		min-width: 280px;
		width: 360px;
		text-align: left;

		// 卡片
		.el-card {
			margin-bottom: 15px;
			border-radius: 8px;
		}

		// 登录按钮
		.button-login {
			width: 100%;
		}

		// 输入框左边的图表区域缩窄
		.el-input-group__prepend {
			padding: 0px 14px;
		}

		.login-code {
			height: 40px - 2px;
			display: block;
			margin: 0px -20px;
			border-top-right-radius: 2px;
			border-bottom-right-radius: 2px;
		}

		// 登陆选项
		.page-login--options {
			margin: 0px;
			padding: 0px;
			font-size: 14px;
			color: $color-primary;
			margin-bottom: 15px;
			font-weight: bold;
		}

		.page-login--quick {
			width: 100%;
		}
	}

	// 快速选择用户面板
	.page-login--quick-user {
		@extend %flex-center-col;
		padding: 10px 0px;
		border-radius: 4px;

		&:hover {
			background-color: $color-bg;

			i {
				color: $color-text-normal;
			}

			span {
				color: $color-text-normal;
			}
		}

		i {
			font-size: 36px;
			color: $color-text-sub;
		}

		span {
			font-size: 12px;
			margin-top: 10px;
			color: $color-text-sub;
		}
	}

	// footer
	.page-login--content-footer {
		padding: 1em 0;

		.page-login--content-footer-locales {
			padding: 0px;
			margin: 0px;
			margin-bottom: 15px;
			font-size: 12px;
			line-height: 12px;
			text-align: center;
			color: $color-text-normal;

			a {
				color: $color-text-normal;
				margin: 0 0.5em;

				&:hover {
					color: $color-text-main;
				}
			}
		}

		.page-login--content-footer-copyright {
			padding: 0px;
			margin: 0px;
			margin-bottom: 10px;
			font-size: 12px;
			line-height: 12px;
			text-align: center;
			color: $color-text-normal;

			a {
				color: $color-text-normal;
			}
		}

		.page-login--content-footer-options {
			padding: 0px;
			margin: 0px;
			font-size: 12px;
			line-height: 12px;
			text-align: center;

			a {
				color: $color-text-normal;
				margin: 0 1em;
			}
		}
	}

	// 背景
	.circles {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		margin: 0px;
		padding: 0px;

		li {
			position: absolute;
			display: block;
			list-style: none;
			width: 20px;
			height: 20px;
			background: #fff;
			animation: animate 25s linear infinite;
			bottom: -200px;
			@keyframes animate {
				0% {
					transform: translateY(0) rotate(0deg);
					opacity: 1;
					border-radius: 0;
				}
				100% {
					transform: translateY(-1000px) rotate(720deg);
					opacity: 0;
					border-radius: 50%;
				}
			}

			&:nth-child(1) {
				left: 15%;
				width: 80px;
				height: 80px;
				animation-delay: 0s;
			}

			&:nth-child(2) {
				left: 5%;
				width: 20px;
				height: 20px;
				animation-delay: 2s;
				animation-duration: 12s;
			}

			&:nth-child(3) {
				left: 70%;
				width: 20px;
				height: 20px;
				animation-delay: 4s;
			}

			&:nth-child(4) {
				left: 40%;
				width: 60px;
				height: 60px;
				animation-delay: 0s;
				animation-duration: 18s;
			}

			&:nth-child(5) {
				left: 65%;
				width: 20px;
				height: 20px;
				animation-delay: 0s;
			}

			&:nth-child(6) {
				left: 75%;
				width: 150px;
				height: 150px;
				animation-delay: 3s;
			}

			&:nth-child(7) {
				left: 35%;
				width: 200px;
				height: 200px;
				animation-delay: 7s;
			}

			&:nth-child(8) {
				left: 50%;
				width: 25px;
				height: 25px;
				animation-delay: 15s;
				animation-duration: 45s;
			}

			&:nth-child(9) {
				left: 20%;
				width: 15px;
				height: 15px;
				animation-delay: 2s;
				animation-duration: 35s;
			}

			&:nth-child(10) {
				left: 85%;
				width: 150px;
				height: 150px;
				animation-delay: 0s;
				animation-duration: 11s;
			}
		}
	}
}

::-webkit-input-placeholder {
	/* WebKit browsers */
	color: #e3e3e6;
}

::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #e3e3e6;
}

:-ms-input-placeholder {
	/* Internet Explorer 10+ */
	color: #e3e3e6;
}

.div_txt_info {
	font-size: 36px;
	font-weight: 700;
	margin-bottom: 20px;
}
</style>
